export default "__VITE_ASSET__DTM4IRPl__"